// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false, 
    oktaEnable: false, 
    // originUrl: window.location.origin,
    originUrl: "https://qlab02.dash.ftl.corporate.t-mobile.com",
    oktaClientId: "0oafpdgdolg6cc3BW0h7",
    oktaOrgUrl: "https://t-mobile.oktapreview.com",
    basicAuth: "Basic dGVzdGFkbWluOnBhc3N3MHJk"
};